import { createFileRoute } from "@tanstack/react-router";
import { type } from "arktype";
import { ResetPasswordForm } from "~/components/views/auth/reset-password-form";

export const Route = createFileRoute("/auth/reset-password/")({
	component: Page,
	validateSearch: type({
		token: type("string").optional(),
	}),
});

function Page() {
	const { token } = Route.useSearch();

	return <ResetPasswordForm token={token} />;
}
